// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-lqcRDQV7","sub_logo":"sub_logo-3_cZOKZr","breadcrumbs":"breadcrumbs-1z64XJ7S"};